// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    font-family: var(--font-family), sans-serif;
    font-size: var(--p2-medium-font-size);
    color: var(--text-default);
    display: flex;
    flex-direction: column;
}

.swiftref-input label {
    display: inline-block;
    padding: var(--spacing-05) 0;
    font-family: var(--p2-medium-font-family), sans-serif;
    font-size: var(--p2-medium-font-size);
    letter-spacing: var(--p2-medium-font-family);
    line-height: var(--p2-medium-line-height);
    font-weight: var(--p2-medium-font-weight);
}

.swiftref-input .input-container {
    display: grid;
    position: relative;
}
.swiftref-input input {
    border: 1px solid var(--border-strong);
    border-radius: var(--spacing-05);
    height: calc(var(--spacing-50) - 10px);
    margin: 0;
    min-width: var(--input-min-width);
    padding: var(--spacing-05) var(--spacing-10);
}
.swiftref-input swiftref-icon {
    position: absolute;
    top: calc(var(--spacing-15) + 1px);
    left: var(--spacing-10);
    width: fit-content;
}
.swiftref-input swiftref-icon ~ input {
    padding-left: var(--spacing-40) !important;
}
.swiftref-input input::placeholder {
    color: var(--text-placeholder);
    font-family: var(--p2-regular-font-family), sans-serif;
    font-size: var(--p2-regular-font-size);
}
.swiftref-input input:focus {
    outline: 1px solid var(--border-focused);
}

.swiftref-input swiftref-message {
    margin-top: var(--spacing-05);
}

.swiftref-input .clear-icon {
    position: absolute;
    top: calc(var(--spacing-10));
    right: 0;
    font-weight: bold;
    font-size: 16px;
    color: var(--icon-light);
    cursor: pointer;
    width: 20px;
    height: 20px;
}
/*.message {*/
/*    color: var(--text-placeholder);*/
/*    font-size: var(--p2-regular-font-size);*/
/*}*/

/*:host([state="invalid"]) .message,*/
/*:host([state="error"]) .message {*/
/*    color: var( --text-error);*/
/*}*/
:host([state="invalid"]) input,
:host([state="error"]) input {
    border-color: var(--border-error-strong)
}
:host([state="warning"]) input {
    border-color: var(--border-warning-strong)
}

:host([required]) label:not(.message)::after {
    content: "*";
    color: var( --text-error);
    left: var(--spacing-05);
    position: relative;
}
:host([disabled]) input {
    background: var(--background-disabled);
    border-color: var(--background-strong);
}
:host([disabled]) label,
:host([disabled]) swiftref-message {
    opacity: .6;
}
:host([clear_icon]) input {
    padding-right: var(--spacing-40) !important;
}

@media (max-width: 940px) {

    .swiftref-input input {
        min-width: unset;
    }
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/input/style/index.css"],"names":[],"mappings":"AAAA;IACI,2CAA2C;IAC3C,qCAAqC;IACrC,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,qDAAqD;IACrD,qCAAqC;IACrC,4CAA4C;IAC5C,yCAAyC;IACzC,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,sCAAsC;IACtC,gCAAgC;IAChC,sCAAsC;IACtC,SAAS;IACT,iCAAiC;IACjC,4CAA4C;AAChD;AACA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,8BAA8B;IAC9B,sDAAsD;IACtD,sCAAsC;AAC1C;AACA;IACI,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,wBAAwB;IACxB,eAAe;IACf,WAAW;IACX,YAAY;AAChB;AACA,aAAa;AACb,sCAAsC;AACtC,8CAA8C;AAC9C,IAAI;;AAEJ,qCAAqC;AACrC,oCAAoC;AACpC,iCAAiC;AACjC,IAAI;AACJ;;IAEI;AACJ;AACA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,sCAAsC;IACtC,sCAAsC;AAC1C;AACA;;IAEI,WAAW;AACf;AACA;IACI,2CAA2C;AAC/C;;AAEA;;IAEI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[":host {\n    font-family: var(--font-family), sans-serif;\n    font-size: var(--p2-medium-font-size);\n    color: var(--text-default);\n    display: flex;\n    flex-direction: column;\n}\n\n.swiftref-input label {\n    display: inline-block;\n    padding: var(--spacing-05) 0;\n    font-family: var(--p2-medium-font-family), sans-serif;\n    font-size: var(--p2-medium-font-size);\n    letter-spacing: var(--p2-medium-font-family);\n    line-height: var(--p2-medium-line-height);\n    font-weight: var(--p2-medium-font-weight);\n}\n\n.swiftref-input .input-container {\n    display: grid;\n    position: relative;\n}\n.swiftref-input input {\n    border: 1px solid var(--border-strong);\n    border-radius: var(--spacing-05);\n    height: calc(var(--spacing-50) - 10px);\n    margin: 0;\n    min-width: var(--input-min-width);\n    padding: var(--spacing-05) var(--spacing-10);\n}\n.swiftref-input swiftref-icon {\n    position: absolute;\n    top: calc(var(--spacing-15) + 1px);\n    left: var(--spacing-10);\n    width: fit-content;\n}\n.swiftref-input swiftref-icon ~ input {\n    padding-left: var(--spacing-40) !important;\n}\n.swiftref-input input::placeholder {\n    color: var(--text-placeholder);\n    font-family: var(--p2-regular-font-family), sans-serif;\n    font-size: var(--p2-regular-font-size);\n}\n.swiftref-input input:focus {\n    outline: 1px solid var(--border-focused);\n}\n\n.swiftref-input swiftref-message {\n    margin-top: var(--spacing-05);\n}\n\n.swiftref-input .clear-icon {\n    position: absolute;\n    top: calc(var(--spacing-10));\n    right: 0;\n    font-weight: bold;\n    font-size: 16px;\n    color: var(--icon-light);\n    cursor: pointer;\n    width: 20px;\n    height: 20px;\n}\n/*.message {*/\n/*    color: var(--text-placeholder);*/\n/*    font-size: var(--p2-regular-font-size);*/\n/*}*/\n\n/*:host([state=\"invalid\"]) .message,*/\n/*:host([state=\"error\"]) .message {*/\n/*    color: var( --text-error);*/\n/*}*/\n:host([state=\"invalid\"]) input,\n:host([state=\"error\"]) input {\n    border-color: var(--border-error-strong)\n}\n:host([state=\"warning\"]) input {\n    border-color: var(--border-warning-strong)\n}\n\n:host([required]) label:not(.message)::after {\n    content: \"*\";\n    color: var( --text-error);\n    left: var(--spacing-05);\n    position: relative;\n}\n:host([disabled]) input {\n    background: var(--background-disabled);\n    border-color: var(--background-strong);\n}\n:host([disabled]) label,\n:host([disabled]) swiftref-message {\n    opacity: .6;\n}\n:host([clear_icon]) input {\n    padding-right: var(--spacing-40) !important;\n}\n\n@media (max-width: 940px) {\n\n    .swiftref-input input {\n        min-width: unset;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
